var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "columns is-centered" },
      [
        _c("div", { staticClass: "column is-half" }, [
          _c("canvas", { ref: "canvas", attrs: { id: "canvas", hidden: "" } })
        ]),
        _vm._v(" "),
        _c("video", {
          ref: "video",
          attrs: { id: "video", width: "480", autoplay: "", hidden: "" }
        }),
        _vm._v(" "),
        _c("b-loading", {
          staticStyle: { "background-color": "rgba(0, 0, 0, 0.8)" },
          attrs: { "is-full-page": true, "can-cancel": false },
          model: {
            value: _vm.isLoading,
            callback: function($$v) {
              _vm.isLoading = $$v
            },
            expression: "isLoading"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "columns is-centered" }, [
      _c("div", { staticClass: "column is-half" }, [
        _c("p", [_vm._v("QRコードをかざしてください")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = JKbO
// module chunks = 0